import React, { useRef } from "react";
import word_icon from "../../../../assets/Word_icon.png";
import Survey_Analysis from "../Print_Report/Survey_Analysis";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import { Packer, Document, Paragraph, ImageRun } from "docx";
import Title from "../../../../utilities/PDF/Title";
import Tooltip from "../../../../utilities/Tooltip";

const Docx_Comp = ({ study_id, studyname, elem }) => {
  const captureRef = useRef(null); // Reference to the DOM element

  const generate = async () => {
    if (captureRef.current) {
      try {
        // Ensure full scrollable content is captured
        const canvas = await html2canvas(captureRef.current, {
          scale: window.devicePixelRatio, // High quality
          useCORS: true, // Handle external images
          scrollX: 0,
          scrollY: 0,
          windowWidth: document.documentElement.scrollWidth,
          windowHeight: document.documentElement.scrollHeight,
        });

        const imageData = canvas.toDataURL("image/png");

        // Get dynamic width and height
        const imageWidth = Math.min(canvas.width / 2, 600); // Limit max width
        const imageHeight = (canvas.height / canvas.width) * imageWidth; // Keep aspect ratio

        const base64Data = imageData.split(",")[1];
        const doc = new Document({
          sections: [
            {
              children: [
                new Paragraph({
                  children: [
                    new ImageRun({
                      data: base64Data,
                      transformation: {
                        width: imageWidth,
                        height: imageHeight,
                      },
                    }),
                  ],
                }),
              ],
            },
          ],
        });

        // Generate .docx and trigger download
        const blob = await Packer.toBlob(doc);
        saveAs(blob, "example.docx");
        console.log("Document created successfully");
      } catch (error) {
        console.error("Error generating document:", error);
      }
    }
  };

  return (
    <>
      <Tooltip element={"Export as a Docx file"} id="docx_btn">
        <button
          id="btn_comp"
          style={{
            width: "40px",
            height: "40px",
            backgroundColor: "#fff",
            boxShadow: "0px 2px 6px #0000000D",
            paddingTop: "7px",
          }}
          onClick={generate}
        >
          <img
            src={word_icon}
            style={{
              height: "15px",
            }}
          />
        </button>
      </Tooltip>
      <div
        ref={captureRef}
        id="capture-area"
        style={{
          padding: "20px",
          // background: "",
          textAlign: "center",
          width: "100%", // Make it responsive
          // maxWidth: "800px", // Optional max width
          position: "fixed",
          // height: "100%",
          // overflowY: "auto",
          zIndex: -100,
          left: -100000,
          top: -100000,
        }}
      >
        <Title
          title={studyname + " survey analysis"}
          // border_b_null={true}
        />
        <Survey_Analysis studyname={studyname} s_id={study_id} />
      </div>
    </>
  );
};

export default Docx_Comp;
